/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Technologies1Inputs */

const id_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologi`)
};

const ms_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologi`)
};

const da_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologier`)
};

const de_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologien`)
};

const en_us2_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologies`)
};

const es_es2_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologías`)
};

const es_mx2_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologías`)
};

const fil_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Teknolohiya`)
};

const fr_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologies`)
};

const it_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologie`)
};

const hu_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technológiák`)
};

const nl_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologieën`)
};

const no_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologier`)
};

const pl_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologie`)
};

const pt_br2_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologias`)
};

const pt_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologias`)
};

const ro_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehnologii`)
};

const fi_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologiat`)
};

const sv_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologier`)
};

const vi_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nghệ`)
};

const tr_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknolojiler`)
};

const cs_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologie`)
};

const bg_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технологии`)
};

const ru_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технологии`)
};

const uk_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технології`)
};

const ar_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقنيات`)
};

const hi_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रौद्योगिकियाँ`)
};

const th_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เทคโนโลยี`)
};

const ja_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テクノロジー`)
};

const zh_cn2_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术栈`)
};

const zh_hant1_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術棧`)
};

const ko_offerdetail_table_technologies1 = /** @type {(inputs: Offerdetail_Table_Technologies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기술`)
};

/**
* | output |
* | --- |
* | "Technologies" |
*
* @param {Offerdetail_Table_Technologies1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_technologies1 = /** @type {((inputs?: Offerdetail_Table_Technologies1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Technologies1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_technologies1(inputs)
	if (locale === "ms") return ms_offerdetail_table_technologies1(inputs)
	if (locale === "da") return da_offerdetail_table_technologies1(inputs)
	if (locale === "de") return de_offerdetail_table_technologies1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_technologies1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_technologies1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_technologies1(inputs)
	if (locale === "fil") return fil_offerdetail_table_technologies1(inputs)
	if (locale === "fr") return fr_offerdetail_table_technologies1(inputs)
	if (locale === "it") return it_offerdetail_table_technologies1(inputs)
	if (locale === "hu") return hu_offerdetail_table_technologies1(inputs)
	if (locale === "nl") return nl_offerdetail_table_technologies1(inputs)
	if (locale === "no") return no_offerdetail_table_technologies1(inputs)
	if (locale === "pl") return pl_offerdetail_table_technologies1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_technologies1(inputs)
	if (locale === "pt") return pt_offerdetail_table_technologies1(inputs)
	if (locale === "ro") return ro_offerdetail_table_technologies1(inputs)
	if (locale === "fi") return fi_offerdetail_table_technologies1(inputs)
	if (locale === "sv") return sv_offerdetail_table_technologies1(inputs)
	if (locale === "vi") return vi_offerdetail_table_technologies1(inputs)
	if (locale === "tr") return tr_offerdetail_table_technologies1(inputs)
	if (locale === "cs") return cs_offerdetail_table_technologies1(inputs)
	if (locale === "bg") return bg_offerdetail_table_technologies1(inputs)
	if (locale === "ru") return ru_offerdetail_table_technologies1(inputs)
	if (locale === "uk") return uk_offerdetail_table_technologies1(inputs)
	if (locale === "ar") return ar_offerdetail_table_technologies1(inputs)
	if (locale === "hi") return hi_offerdetail_table_technologies1(inputs)
	if (locale === "th") return th_offerdetail_table_technologies1(inputs)
	if (locale === "ja") return ja_offerdetail_table_technologies1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_technologies1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_technologies1(inputs)
	return ko_offerdetail_table_technologies1(inputs)
});
export { offerdetail_table_technologies1 as "offerDetail.table.technologies" }